import { ISignInFailAction, ISignInSuccessAction, ISignOutSuccessAction } from './loginActions';

export type LoginActionTypes = ISignInFailAction | ISignInSuccessAction | ISignOutSuccessAction;

export enum LoginActionTypeKeys {
    SIGNIN_SUCCESS = 'LOGIN/SIGNIN_SUCCESS',
    SIGNOUT_SUCCESS = 'LOGIN/SIGNOUT_SUCCESS',
    SIGNIN_FAIL = 'LOGIN/SIGNIN_FAIL',
}


// WEBPACK FOOTER //
// ./src/actions/loginActionTypes.ts